import UserManagementReducer from 'store/user-management/reducer';

export { default as userManagementTypes } from 'store/user-management/types';
export { default as userManagementSelectors } from 'store/user-management/selectors';

export default UserManagementReducer;
